import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import { Settings04 } from "@untitled-ui/icons-react/build/esm";
import { useFileSettings } from "~/hooks/use-file-settings";
import { ProcessFilterDialog } from "./process-filter-dialog";
export const ProcessFilter = () => {
  const {
    hideProcess,
    handleHideProcess,
    handleUnhideProcess,
    handleHideProcessModelOpen,
    handleHideProcessModelClose
  } = useFileSettings();
  return <>
			<Box sx={{
      backgroundColor: theme => theme.palette.mode === "dark" ? "neutral.800" : "neutral.100",
      borderRadius: 2.5,
      mt: 7,
      mx: 1
    }} data-sentry-element="Box" data-sentry-source-file="process-filter.tsx">
				<Stack alignItems="center" direction="row" onClick={handleHideProcessModelOpen} spacing={1} sx={{
        cursor: "pointer",
        p: 2,
        userSelect: "none"
      }} data-sentry-element="Stack" data-sentry-source-file="process-filter.tsx">
					<SvgIcon color="action" data-sentry-element="SvgIcon" data-sentry-source-file="process-filter.tsx">
						<Settings04 data-sentry-element="Settings04" data-sentry-source-file="process-filter.tsx" />
					</SvgIcon>
				</Stack>
			</Box>
			{hideProcess?.isModelOpen && <ProcessFilterDialog selectedProcesses={hideProcess.selectedProcesses ?? []} hideProcess={processId => handleHideProcess(processId)} unhideProcess={processId => handleUnhideProcess(processId)} onClose={handleHideProcessModelClose} />}
		</>;
};